export default class ChangedPlanModel {
    id: number;
    idContrato: number;
    idConvenio: number;
    idCategoria: string;
    aceite: boolean | null;
    dataSolicitacao: string;
    planoAtual: string;
    planoNovo: string;
    num_contrato: string;
    nome: string;
    cpf: string

    constructor(
        id: number,
        idContrato: number,
        idConvenio: number,
        idCategoria: string,
        aceite: boolean | null,
        dataSolicitacao: string,
        planoAtual: string,
        planoNovo: string,
        num_contrato: string,
        nome: string,
        cpf: string
    ) {
        this.id = id;
        this.idContrato = idContrato;
        this.idConvenio = idConvenio;
        this.idCategoria = idCategoria;
        this.aceite = aceite;
        this.dataSolicitacao = dataSolicitacao;
        this.planoAtual = planoAtual;
        this.planoNovo = planoNovo;
        this.num_contrato = num_contrato;
        this.nome = nome;
        this.cpf = cpf;
    }

    static fromApiResponse(data: any): ChangedPlanModel {
        return new ChangedPlanModel(
            data.id,
            data.id_contrato,
            data.id_convenio,
            data.id_categoria,
            data.aceite,
            data.data_solicitacao,
            data.plano_atual,
            data.plano_novo,
            data.num_contrato,
            data.nome,
            data.cpf,
        );
    }
}
